import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Table, Modal, Form, Checkbox, Upload, Button } from 'antd';
import validate from '../../dev/devApply/validate';

const {
  checkLen,
} = validate;
const CheckboxGroup = Checkbox.Group;
const create = Form.create;
const FormItem = Form.Item;
@inject('sysStore')
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'sys-user',
  }
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      record: {},
      showFileError: false,
    }
  }
  componentDidMount() {
    const { sysStore: { init, getFbList } } = this.props;
    init();
    getFbList();
  }
  edit = (record) => {
    const { sysStore: { setMobxState } } = this.props;
    setMobxState({ fbFiles: record.logofile });
    this.setState({ record, showFileError: record.logofile.length === 0, visible: true }, () => {
      this.props.form.setFieldsValue({
        inter: record.inter ? record.inter.split(',') : [],
        sdatabase: record.sdatabase ? record.sdatabase.split(',') : [],
      });
    });
  }
  changeFbApp = (record, operateType) => {
    const { sysStore: { editFb, getFbList } } = this.props;
    const params = {
      uuid: record.uuid,
      operateType,
      identi: record.identification,
    };
    editFb(params).then((data) => {
      getFbList();
    });
  }
  getColumns = () => {
    const { prefixCls } = this.props;
    return [
      { title: '应用编码', dataIndex: 'identification', key: 'identification', width: '30%' },
      { title: '应用名称', dataIndex: 'name', key: 'name', width: '40%' },
      {
        title: '操作', dataIndex: 'op', key: 'op', width: '30%', render: (text, record) => {
          return (
            <div className={`${prefixCls}-joinList-btn`}>
              <span onClick={() => this.changeFbApp(record, record.fb_close === '1' ? 1 : 2)}>{record.fb_close === "1" ? '发布' : '下架'}</span>
              {
                record.fb_close === "1" && (<span onClick={() => this.edit(record)}>编辑</span>)
              }
            </div>
          )
        }
      },
    ];
  }
  onTableChange = (current, pageSize) => {
    const { sysStore: { getFbList, setMobxState } } = this.props;
    setMobxState({ current, pageSize });
    getFbList({ current, pageSize });
  }
  onCancel = () => {
    this.setState({ visible: false });
    this.props.form.resetFields();
  }
  getFileId = (files) => {
    return files.map(v => v.response ? v.response.id : v.uid ? v.uid : v.id);
  }
  onSubmit = () => {
    const { record } = this.state;
    const { form, sysStore: { editFb, init, getFbList, fbFiles } } = this.props;
    form.validateFields((error, values) => {
      if (!error) {
        this.setState({
          showFileError: toJS(fbFiles).length === 0,
        }, () => {
          if (!this.state.showFileError) {
            editFb({
              uuid: record.uuid,
              identi: record.identification,
              operateType: 0,
              sdatabase: values.sdatabase.join(),
              inter: values.inter.join(),
              logofile: this.getFileId(toJS(fbFiles)),
            }).then(() => {
              init();
              getFbList();
              this.setState({ visible: false });
            })
          }
        })
      }
    });
  }
  handleChange = (info) => {
    const { sysStore: { setMobxState } } = this.props;
    let fileList = [...info.fileList];
    // 1. Limit the number of uploaded files
    fileList = fileList.slice(-2);

    // 2. Read from response and show file link
    fileList = fileList.map(file => {
      if (file.response) {
        file.url = file.response.url;
      }
      return file;
    });
    setMobxState({ fbFiles: [fileList.reverse()[0]] });
  };

  getModal = () => {
    const { record, showFileError } = this.state;
    const { form: {
      isFieldValidating,　getFieldError,　getFieldProps,
    }, sysStore: { setMobxState, fbFiles } } = this.props;
    const formLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    }
    return (
      <Form>
        <FormItem
          required
          label="浏览器兼容："
          {...formLayout}
			    help={isFieldValidating('inter') ? '校验中...' : (getFieldError('inter') || []).join(', ')}
        >
          <CheckboxGroup
				    	 {...getFieldProps('inter',
                 {
                    rules: [{ validator: checkLen }]
					      	}
				      	)} 
				   options={['IE8', 'IE9', 'IE10','IE11','chrome']} />
        </FormItem>
        <FormItem
          required
          label="数据库支持："
          {...formLayout}
				  help={isFieldValidating('sdatabase') ? '校验中...' : (getFieldError('sdatabase') || []).join(', ')}
        >
   	      <CheckboxGroup
				    {...getFieldProps('sdatabase',
              {
						    rules: [{ validator: checkLen },]
						 	}
						)} 
		    		options={['oracle', 'sqlserver']} />
        </FormItem>
        <FormItem
          required
          label="应用图标："
          {...formLayout}
        >
          <Upload
            action={window.server + "/v2/sys/fbfile"}
            listType="picture"
            data={{ type: `logofile_${record.identification}` }}
					  fileList={toJS(fbFiles)}
            onChange={(info) => {
              const status = info.file.status;
              this.handleChange(info);
              if (status === 'done') {
                this.setState({ showFileError: false });
              }
            }}
            onRemove={() => {
              this.setState({ showFileError: true });
              setMobxState({ fbFiles: [] });
            }}
				  >
            <Button type="ghost" icon="upload">
              点击上传
            </Button>
            <span><a href="ui/file/imgs.rar" target="_blank">[点击下载参考图标，高270、宽270]</a></span>
          </Upload>
          {
            showFileError && (
              <span style={{ color: '#f00' }}>此选项必填，不能为空</span>
            )
          }
        </FormItem>
      </Form>
    )
  }
  render() {
    const { visible } = this.state;
    const { prefixCls, sysStore: { fbList, fbCount, loading, pageSize, current, formLoading } } = this.props;
    return (
      <div className={`${prefixCls}`}>
        <Table
          rowKey="id"
          loading={loading}
          bordered={true}
          dataSource={toJS(fbList)}
          columns={this.getColumns()}
          pagination={{
            total: fbCount,
            pageSize: pageSize,
            current: current,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: total => (<span>共{total}条</span>),
            onChange: this.onTableChange,
            onShowSizeChange: (page, size) => this.onTableChange(1, size),
          }} />
        <Modal
          title="编辑应用"
          visible={visible}
          onCancel={this.onCancel}
          footer={[
            (<Button key="submit" type="primary" onClick={this.onSubmit} loading={formLoading}>提交</Button>),
            (<Button key="cancel" onClick={this.onCancel}>取消</Button>),
          ]}
          width={600}
        >
          { visible ? this.getModal() : null }
        </Modal>
      </div>
    )
  }
}

Main = create()(Main);
export default Main;


// WEBPACK FOOTER //
// ./src/components/sys/app/FbAppList.js